<template>
    <v-hover v-slot="{ hover }">
    <v-card
        height="100%"
        :elevation="hover ? 12 : 2">
            <v-card-title>
                {{ project.name }}
            </v-card-title>
            <v-card-subtitle>
                {{ project.date }}
            </v-card-subtitle>
            <v-card-text
                v-for="(description, index) in project.descriptions"
                :key="index">
                {{ description }}
            </v-card-text>
            <v-card-text>
                Technologies used in the project:
                <div
                    v-for="(technology, index) in project.technologies"
                    :key="index">
                    <v-icon>
                        mdi-chevron-right
                    </v-icon>
                    {{ technology }}
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div
                v-for="link in project.links"
                :key="link.name">
                    <v-btn
                        class="ma-1"
                        :href="link.url"
                        target="_blank">
                        {{ link.name }}
                    </v-btn>
                </div>
            </v-card-actions>
    </v-card>
    </v-hover>
</template>

<script>
export default {
    name: 'Project',
    props: {
        project: Object,
    },
}
</script>

<style scoped>

</style>